import React from 'react';
import { OnboardingCompanyUnits } from './OnboardingCompanyUnits';
import { OnboardingAdmin } from './OnboardingAdmin';
import { OnboardingAddLegislation } from './OnboardingAddLegislation';
import { OnboardingLawNotes } from './OnboardingLawNotes';
import { OnboardingRequirements } from './OnboardingRequirements';

export const OnboardingConfiguration = ({ step }: { step: number }) => {
  if (step === 0) return <OnboardingCompanyUnits />;
  if (step === 6) return <OnboardingAdmin />;
  if (step === 1) return <OnboardingAddLegislation />;
  if (step === 3) return <OnboardingLawNotes />;
  if (step === 4) return <OnboardingRequirements />;
  return null;
};
